import { useEffect, useState } from 'react';
import { db } from '../lib/firebase';
import {
  collection, query, orderBy, onSnapshot,
  addDoc, serverTimestamp, Timestamp,
} from 'firebase/firestore';

function fmtAgo(ts) {
  if (!ts) return '';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  const s = Math.floor((Date.now() - d) / 1000);
  if (s < 60)  return 'just now';
  if (s < 3600) return `${Math.floor(s/60)}m ago`;
  if (s < 86400) return `${Math.floor(s/3600)}h ago`;
  return `${Math.floor(s/86400)}d ago`;
}

export default function VibesScreen({ user, userData }) {
  const [vibes, setVibes]       = useState([]);
  const [modal, setModal]       = useState(false);
  const [emoji, setEmoji]       = useState('');
  const [caption, setCaption]   = useState('');

  useEffect(() => {
    const now = Timestamp.now();
    const cutoff = new Timestamp(now.seconds - 86400, 0);
    const q = query(collection(db, 'vibes'), orderBy('timestamp', 'desc'));
    return onSnapshot(q, snap => {
      const v = [];
      snap.forEach(d => {
        const data = d.data();
        if (data.expiresAt && data.expiresAt.toDate() > new Date()) v.push({ id: d.id, ...data });
      });
      setVibes(v);
    });
  }, []);

  async function postVibe() {
    if (!emoji && !caption) return;
    const exp = new Date(); exp.setHours(exp.getHours() + 24);
    await addDoc(collection(db, 'vibes'), {
      emoji,
      caption,
      senderId:       user.uid,
      senderName:     userData.displayName,
      senderInitials: userData.initials,
      senderAvatarBg: userData.avatarBg,
      senderAvatarText: userData.avatarText,
      timestamp:  serverTimestamp(),
      expiresAt:  Timestamp.fromDate(exp),
    });
    setEmoji(''); setCaption(''); setModal(false);
  }

  return (
    <div className="screen" style={{ position: 'relative' }}>
      <div className="screen-header">
        <div className="screen-title">vibes ✨</div>
      </div>

      <div className="scroll-area">
        {vibes.length === 0 && (
          <div style={{ textAlign: 'center', color: 'var(--text-muted)', marginTop: 60, fontSize: 14 }}>
            no vibes yet — be first ✨
          </div>
        )}
        {vibes.map(v => (
          <div key={v.id} className="vibe-card">
            <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 10 }}>
              <div className="avatar sm" style={{ background: v.senderAvatarBg, color: v.senderAvatarText }}>
                {v.senderInitials}
              </div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{v.senderName}</div>
                <div className="vibe-meta">{fmtAgo(v.timestamp)}</div>
              </div>
            </div>
            {v.emoji && <div className="vibe-emoji">{v.emoji}</div>}
            {v.caption && <div className="vibe-caption">{v.caption}</div>}
          </div>
        ))}
      </div>

      <button className="fab" onClick={() => setModal(true)}>
        <i className="ti ti-plus" />
      </button>

      {modal && (
        <div className="modal-backdrop" onClick={() => setModal(false)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div className="modal-handle" />
            <div className="modal-title">drop a vibe</div>
            <input className="modal-input" placeholder="emoji (optional)" value={emoji} onChange={e => setEmoji(e.target.value)} />
            <input className="modal-input" placeholder="what's the vibe?" value={caption} onChange={e => setCaption(e.target.value)} />
            <button className="btn-primary" onClick={postVibe}>post vibe</button>
          </div>
        </div>
      )}
    </div>
  );
}
